import { gql } from "graphql-request";
export const COMPARISON_META = gql`
    query comparisonMeta($url: String) {
        url(url: $url) {
            title
            meta
        }
    }
`;
